export default {
    path: '/letters/:facilityId?/:customerId?/:customerName?/:agreementId?',
    preload: false,
    middlewares: [{
        "rms_ui/validatePermissionsMiddleware": [
            ["file.template_create"],
            "/"
        ]
    }],
}